import { visitTemplatesTranslationKeys } from '../../../translations';
import { VisitTemplateFormController } from '../VisitTemplateForm.types';

import { VisitTemplateFormTextEditor } from './VisitTemplateFormTextEditor';

type VisitTemplateFormRecommendationsTextareaProps = Pick<VisitTemplateFormController, 'register' | 'control'>;

export const VisitTemplateFormRecommendationsTextarea = (
   props: VisitTemplateFormRecommendationsTextareaProps
): JSX.Element => {
   return (
      <VisitTemplateFormTextEditor
         register={props.register}
         control={props.control}
         fieldName={'recommendations'}
         label={visitTemplatesTranslationKeys.recommendations}
         placeholder={visitTemplatesTranslationKeys.enterRecommendations}
         testId={'recommendations'}
      />
   );
};
